interface ImportMeta {
    env: {
        VITE_APIBASEURL: string;
        VITE_TENANT: string;
    };
}

export const getBaseUrl = () => (import.meta as unknown as ImportMeta).env.VITE_APIBASEURL;
export const getTenant = () => (import.meta as unknown as ImportMeta).env.VITE_TENANT;
